/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){

$('.collection-slider-section .slider-mian').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});
    
  
  $('#section-160621652278be607e').bind('inview', function (event, visible) {
    if (visible == true) {
      // element is now visible in the viewport
      $('#section-header').addClass('Header--transparent');
      console.log('visible');
    } else {
      $('#section-header').removeClass('Header--transparent');
      console.log('not visible');
    }
  });
  $('.template-index #section-header').mouseover(function(){
      $('.template-index #section-header').addClass('Header--transparent');
  });
  
//   $('.Product__Tabs').prepend(`<div class="Collapsible Collapsible--large" id="description">
//       <button class="Collapsible__Button Heading u-h6" data-action="toggle-collapsible" aria-expanded="false">DESCRIPTION<span class="Collapsible__Plus"></span>
//       </button>
//       <div class="Collapsible__Inner">
//           <div class="Collapsible__Content">
//           </div>
//       </div>
//   </div>`);
//   $("#description .Collapsible__Content").prepend($(".ProductMeta__Description .Rte"));
});

// $(window).scroll(function(){
//   if ($(window).width() > 575) {
//     if ($(window).scrollTop() >= 300) {
//         $('.ProductForm__Option').slideUp('slow');
//     }
//     else {
//         $('.ProductForm__Option').slideDown('slow');
//     }
//   }
// });